<template>
  <v-snackbar
    top
    color="amber darken-3 text-center"
    class="subtitle-1"
    :timeout="$spec.snakebar_timeout"
    v-model="updateReportSnackbar"
    vertical
  >
    <span>健檢報告已被更新</span>
  </v-snackbar>
</template>
<style scoped>
.v-snack--top {
  top: 40px;
}
</style>
<script>
export default {
  data: () => ({
    updateReportSnackbar: false
  }),
  methods: {
    show() {
      this.updateReportSnackbar = true;
    }
  }
};
</script>